<template>
  <div class="dialog-body">
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
      append-to-body
      width="25%"
    >
      <div class="result">
        <el-row :gutter="24">
          <el-col :span="24">
            <span style="text-align: center; display: block" v-if="type == 0"
              ><i class="el-icon-circle-close"></i>该合同已关闭, 您确定要发起激活申请吗?</span
            >
            <span style="text-align: center; display: block" v-else-if="type == 1"
              ><i class="el-icon-circle-close"></i>该合同已生效, 您确定要发起关闭申请吗?</span
            >
            <span style="text-align: center; display: block" v-else-if="type == 2"
              ><i class="el-icon-circle-close"></i>该合同已生效, 您确定要发起撤销申请吗?</span
            >
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSure">确定</el-button>
        <el-button @click="handleClose">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: 'closeContractDialog',
    props: ['operateFlag'],
    data() {
      return {
        dialogVisible: false,
        type: null,
      };
    },
    methods: {
      openDialog() {
        this.dialogVisible = true;
      },
      handleClose() {
        this.dialogVisible = false;
      },
      async handleSure() {
        this.$emit('confirmCloseOrActivate', this.type);
      },
    },
    watch: {
      operateFlag: {
        handler(val) {
          if (val == null) {
            this.type = null;
          }
          this.type = val;
        },
        immediate: false,
      },
    },
  };
</script>

<style scoped>
  ::v-deep .el-dialog__footer {
    text-align: center;
  }

  .el-dialog .el-dialog__body {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .dialog-body {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .result {
    padding: 20px 100px 20px 100px;
  }

  ::v-deep .el-dialog__footer {
    text-align: center;
  }

  .el-icon-circle-close {
    color: red;
  }
</style>
